function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.376 9.25L12 5.361l-2.388 3.89h4.763zm-5.126 6h-4.5v4.5h4.5v-4.5zM12 2.48l-5.054 8.27h10.108L12 2.48zm1.25 15.02a4.244 4.244 0 014.25-4.25 4.244 4.244 0 014.25 4.25 4.244 4.244 0 01-4.25 4.25 4.244 4.244 0 01-4.25-4.25zm1.5 0a2.75 2.75 0 005.5 0 2.75 2.75 0 00-5.5 0zm-4-3.75v7.5h-7.5v-7.5h7.5z",
  fill: "#111"
});

function SvgCustomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgCustomIcon;